var exports = {
  "n": "xe7b6e3d6--4e81d0--link",
};

module.exports = exports;
